import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Paper, Box, Button, TextField, Grid } from '@mui/material';
import CustomFilterService from '../../../services/CustomFilterService';
import FieldNames from "../../../defaults/FieldNames.json";
import { v4 as uuidv4 } from 'uuid';
import ColorConstants from '../../../defaults/ColorConstants';
import InFormGenericModal from '../../InFormGenericModal';
import { DialogActions, FormControl } from '@mui/material';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { makeStyles } from '@mui/styles';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const theme = createTheme({
  overrides: {
    MuiPaper: {
      root: {
        backgroundColor: "green",
      },
    },
    MuiOutlinedInput: {
      root: {
        "& $notchedOutline": {
          //initial border
          borderColor: ColorConstants.BlueAlien,
        },
        "&:hover $notchedOutline": {
          //border on hover
          borderColor: ColorConstants.BlueAlien,
          border: "2px solid",
        },
        "&$focused $notchedOutline": {
          //border on focus
          borderColor: ColorConstants.BlueAlien,
          border: "2px solid",
        },
      },
    },
  },
});

const useStyles = makeStyles({
  underline: {
    "&&&:before": {
      borderBottom: "2px solid red",
    },
    "&&:after": {
      borderBottom: "2px solid red",
    },
  },
  condensedFormControl: {
    margin: "5px 15px 5px 15px",
    minWidth: 120,
    width: "90%",
  },
  formControl: {
    margin: 15,
    minWidth: 120,
    width: "90%",
  },
  snackBarStyle: {
    top: "120px !important",
  },
});

export default function ShareFilterDialog ({userInfo, onClose, open, filterForShare}) {
  const [userNifcSearchString, setUserNifcSearchString] = useState("");
  const [statusMessage, setStatusMessage] = useState("");
  const [foundUser, setFoundUser] = useState(null);
  const config = useSelector((state) => state.configuration.config);
  const rootServiceUrl = useSelector((state) => state.configuration.rootServiceUrl);
  const nifcToken = useSelector((state) => state.configuration.nifcToken);
  const filterName = (filterForShare) ? filterForShare.Title : '';
  const classes = useStyles();

  const updateSearchString = (value) => {
    if(statusMessage){
      setStatusMessage("")
    }
    setUserNifcSearchString(value);
  }

  const handleClose = () => {
    setUserNifcSearchString("")
    setStatusMessage("");
    onClose();
  }

  const shareFilter = () => {
    //Construct filter to save here from foundUser and filterForShare
    let customFilterForOtherUser = {attributes: {}};
    customFilterForOtherUser.attributes[FieldNames.customFilter.mustMatchAll] = filterForShare[FieldNames.customFilter.mustMatchAll]  ? 'Yes' : 'No';
    customFilterForOtherUser.attributes[FieldNames.customFilter.expression] = filterForShare[FieldNames.customFilter.expression];
    customFilterForOtherUser.attributes[FieldNames.customFilter.sets] = JSON.stringify(filterForShare[FieldNames.customFilter.sets]); 
    customFilterForOtherUser.attributes[FieldNames.customFilter.title] = filterForShare[FieldNames.customFilter.title];
    customFilterForOtherUser.attributes[FieldNames.customFilter.isActive] = FieldNames.yesNo.no;
    customFilterForOtherUser.attributes[FieldNames.customFilter.userCustomFiltersID] = uuidv4();
    customFilterForOtherUser.attributes[FieldNames.customFilter.userID] = foundUser[FieldNames.userFields.userID];
    customFilterForOtherUser.attributes[FieldNames.customFilter.usersJoinId] = foundUser[FieldNames.userFields.id]

    CustomFilterService.shareUserFilter(customFilterForOtherUser).then(response => {
      const displayString = userNifcSearchString;
      const message = (!response.Success) ? 'Filter sent to ' + displayString : '';
      setStatusMessage(message);
      setFoundUser(null);
      setUserNifcSearchString("");
    });
  }

  const searchUser = () => {
    CustomFilterService.searchForUser(userNifcSearchString).then(users => {
      setFoundUser(users?.length ? users[0] : null);
      const message = (!users?.length) ? `User not found` : ``;
      setStatusMessage(message)
    });
  }
  
  return (
    <InFormGenericModal
      openFlag={open}
      closeMethod={handleClose}
      titleText={"Share Filter"}
      displayButton={false}
    >
      <Box
        style={{
          maxHeight: "75vh",
          overflow: "auto",
          maxWidth: "50vw",
          minWidth: "50vw",
        }}
      >
      <Paper elevation={6} style={{ padding: 20, margin: 20 }}>
        <FormControl variant="standard" className={classes.formControl}>
          <ThemeProvider theme={theme}>
            <Grid item size={12} container direction="row" className="grid-item" style={{ alignItems: 'center' }}>
              <Grid item size={3}>
                NIFC Username:
              </Grid>
              <Grid item size={7}>
                <TextField value={userNifcSearchString} fullWidth={true} onChange={(e) => updateSearchString(e.target.value)}/>
              </Grid>
              <Grid item size={2}>
                <Button
                  variant="contained"
                  color='primary'
                  sx={{ marginLeft: 2 }}
                  onClick={searchUser}
                  disabled={userNifcSearchString === ''}
                >
                    Search
                </Button>
              </Grid>
            </Grid>
            {foundUser !== null && 
              <Grid item size={12} container direction="row" className="grid-item" style={{ alignItems: 'center' }} >
                Send "{filterName}" to {userNifcSearchString}? 
              </Grid>
            }
            {statusMessage && 
              <Grid item size={12} container direction="row" className="grid-item" style={{ alignItems: 'center' }} >
                {statusMessage === "User not found" &&
                  <WarningAmberIcon style={{ color: ColorConstants.StatusColors.Draft, fontSize: 30, verticalAlign: 'middle'}} />
                }
                {statusMessage}
              </Grid>
            }
          </ThemeProvider>
        </FormControl>
      </Paper>
      </Box>
      <DialogActions>
        <Button
          variant="contained" 
          color="primary"
          disabled={!foundUser}
          onClick={shareFilter}
        >
          Share Filter
        </Button>
        <Button
          variant="contained" 
          color="primary"
          onClick={handleClose}
        >
          Close
        </Button>
      </DialogActions>
    </InFormGenericModal>
  )
}